import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import { generateUtmExt, getLocalStorage, setLocalStorage } from '../../common/common';
import { renderHeaderOnce } from '../../Store/actions';
import axiosInstance from '../../Store/helper/axiosInstance';
import {
  CL_VIDEO_DETAILS,
  CL_VIDEO_FEATURED,
  CL_VIDEO_RECOMMENDED,
  CL_VIDEO_WATCHED
} from '../QueryKeys/clvideo.key';
import { DASHBOARD_ALL_DATA } from '../QueryKeys/dashboard.key';
import { Ebooks_Details } from '../QueryKeys/ebook.key';
import { MEDWIKI_DETAILS } from '../QueryKeys/medwiki.key';
import { GET_VAULT_LIST } from '../QueryKeys/vault.key';
import useFeedInitialData from '../utils/useFeedInitialData';

const staleTime = 300000;
const cacheTime = 600000;
export const useClinicalVideoFeatured = (onSuccess, onError) => {
  return useQuery(
    CL_VIDEO_FEATURED,
    () => axiosInstance.get('knwlg/archiveVideoList?from=0&to=10&type=featured'),
    {
      refetchOnWindowFocus: false,
      onSuccess,
      onError,
      select: (response) => response.data.data,
      staleTime: staleTime,
      cacheTime: cacheTime
    }
  );
};
export const useClinicalVideoRecommended = (onSuccess, onError) => {
  return useQuery(
    CL_VIDEO_RECOMMENDED,
    () => axiosInstance.get('knwlg/archiveVideoList?from=0&to=10'),
    {
      refetchOnWindowFocus: false,
      onSuccess,
      onError,
      select: (response) => response.data.data,
      staleTime: staleTime,
      cacheTime: cacheTime
    }
  );
};
export const useClinicalVideoWatched = (onSuccess, onError) => {
  return useQuery(CL_VIDEO_WATCHED, () => axiosInstance.get('knwlg/historyvideo?from=0&to=20'), {
    refetchOnWindowFocus: false,
    onSuccess,
    onError,
    select: (response) => response.data.data,
    staleTime: staleTime,
    cacheTime: cacheTime
  });
};
// export const useClinicalVideoDetails = (onSuccess, onError) => {
//   return useQuery(CL_VIDEO_DETAILS, () => axiosInstance.get('knwlg/historyvideo?from=0&to=10'), {
//     onSuccess,
//     onError,
//     select: (response) => response.data.data,
//     staleTime: staleTime,
//     cacheTime: cacheTime
//   });
// };
const fetchClVideo = ({ queryKey }) => {
  const clVideoId = queryKey[1];
  return axiosInstance.get(`knwlg/archiveVideoDetail?type_id=${clVideoId}${generateUtmExt()}`);
};

export const useClinicalVideoDetails = (clVideoId, onSuccess, onError, queryEnabled) => {
  const queryClient = useQueryClient();
  return useQuery([CL_VIDEO_DETAILS, clVideoId], fetchClVideo, {
    initialData: () => {
      const clVideoFeatured = queryClient
        .getQueryData(CL_VIDEO_FEATURED)
        ?.data?.data?.find((_video) => _video.type_id == clVideoId);
      const clVideoRecommended = queryClient
        .getQueryData(CL_VIDEO_RECOMMENDED)
        ?.data?.data?.find((_video) => _video.type_id == clVideoId);
      const clVideoVault = queryClient
        .getQueryData(GET_VAULT_LIST)
        ?.data?.data?.find((_video) => _video.type_id == clVideoId);
      const clVideoDashboard = queryClient
        .getQueryData(DASHBOARD_ALL_DATA)
        ?.data?.data?.find((_video) => _video.type_id == clVideoId);

      const [clVideoChannel, clVideoUiV3Dashboard] = useFeedInitialData(
        'archived_video',
        clVideoId
      );
      const clVideo =
        clVideoFeatured ||
        clVideoRecommended ||
        clVideoVault ||
        clVideoDashboard ||
        clVideoChannel ||
        clVideoUiV3Dashboard;
      if (clVideo) {
        return {
          data: {
            data: {
              ...clVideo,
              video_archive_question: clVideo?.question,
              video_archive_answer: clVideo?.answer
            }
          }
        };
      } else {
        return undefined;
      }
    },
    refetchOnWindowFocus: false,
    select: (response) => response.data.data,
    onSuccess,
    onError,
    enabled: queryEnabled,

    cacheTime: cacheTime
  });
};
const saveLike = (data) => {
  return axiosInstance.post('knwlg/save_like', data);
};
//knwlg/historyvideo?from=${from}&to=${to}
//knwlg/archiveVideoDetail?type_id=645
const returnQueryKeyMutate = (type) => {
  switch (type) {
    case 'comp':
      return MEDWIKI_DETAILS;
    case 'video_archive':
      return CL_VIDEO_DETAILS;
    case 'epub':
      return Ebooks_Details;
    default:
      return '';
  }
};
export const useAddLike = (type, type_id) => {
  const queryClient = useQueryClient();

  return useMutation(saveLike, {
    onMutate: async (obj) => {
      console.log('RQ MUTATION', obj);
      const queryKeysArr = [returnQueryKeyMutate(type), type_id];
      // await queryClient.cancelQueries([CL_VIDEO_DETAILS, type_id]);
      const previousData = queryClient.getQueryData(queryKeysArr);

      queryClient.setQueryData(queryKeysArr, (oldQueryData) => {
        console.log('PREVIOUS', oldQueryData, type_id, type, previousData);
        return {
          ...oldQueryData,
          data: {
            ...oldQueryData.data,
            data: {
              ...oldQueryData.data.data,
              rating: oldQueryData.data.data.myrating
                ? oldQueryData.data.data.rating - 1
                : oldQueryData.data.data.rating + 1,
              myrating: !oldQueryData.data.data.myrating
            }
          }
        };
      });
      return { previousData };
    },
    onError: (_err, _obj, context) => {
      // queryClient.setQueryData([CL_VIDEO_DETAILS, type_id], context.previousData);
    },
    onSettled: () => {
      queryClient.invalidateQueries([CL_VIDEO_DETAILS, type_id]);
    }
  });
};
const saveVault = (data) => {
  return axiosInstance.post('knwlg/vault_switching', data);
};
export const useAddVault = (type, type_id) => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  return useMutation(saveVault, {
    onMutate: async (obj) => {
      console.log('RQ MUTATION', obj);
      const queryKeysArr = [returnQueryKeyMutate(type), type_id];
      // await queryClient.cancelQueries([CL_VIDEO_DETAILS, type_id]);
      const previousData = queryClient.getQueryData(queryKeysArr);

      queryClient.setQueryData(queryKeysArr, (oldQueryData) => {
        // console.log('PREVIOUS', oldQueryData);
        return {
          ...oldQueryData,
          data: {
            ...oldQueryData.data,
            data: {
              ...oldQueryData.data.data,
              vault: oldQueryData.data.data.vault == 0 ? 1 : 0
            }
          }
        };
      });
      return { previousData };
    },
    onError: (_err, _obj, context) => {
      // queryClient.setQueryData([CL_VIDEO_DETAILS, type_id], context.previousData);
    },
    onSettled: () => {
      queryClient.invalidateQueries([CL_VIDEO_DETAILS, type_id]);
    },
    onSuccess: (resp) => {
      const res = resp.data;
      let vaultCount = getLocalStorage('vaultCount', false)
        ? parseInt(getLocalStorage('vaultCount', 0))
        : 0;
      // console.log('VAULT', vaultCount);
      if (res.data == 0) {
        setLocalStorage('vaultCount', vaultCount - 1);
      } else {
        setLocalStorage('vaultCount', vaultCount + 1);
      }
      dispatch(renderHeaderOnce());
    }
  });
};
